// The groups a user can pick when a product has no resistance group of its own (an "Ander" product, or one Chris has not classified yet).
// From the "Resistance groups" list of the Spuit Program sheet (MyPack SST.xlsx). Products themselves keep their group in products.resistanceGroup.
export const RESISTANCE_GROUP_LIST = [
  "FRAC 1",
  "FRAC 3",
  "FRAC 4",
  "FRAC 7",
  "FRAC 11",
  "FRAC 12",
  "FRAC 21",
  "FRAC 22",
  "FRAC 27",
  "FRAC 28",
  "FRAC 29",
  "FRAC 33",
  "FRAC 40",
  "FRAC 43",
  "FRAC 49",
  "FRAC M01",
  "FRAC M03",
  "FRAC M05",
  "FRAC P07",
  "FRAC 4 + M",
  "FRAC 7 + 3",
  "FRAC 11 + 3",
  "FRAC 11 + M05",
  "IRAC 1A",
  "IRAC 1B",
  "IRAC 3A",
  "IRAC 4A",
  "IRAC 5",
  "IRAC 6",
  "IRAC 9B",
  "IRAC 13",
  "IRAC 15",
  "IRAC 17",
  "IRAC 18",
  "IRAC 22A",
  "IRAC 23",
  "IRAC 28",
  "IRAC UN",
  "IRAC 6 + 15",
  "IRAC 28 + 3A",
  "HRAC 1",
  "HRAC 2",
  "HRAC 3",
  "HRAC 5",
  "HRAC 9",
  "HRAC 14",
  "HRAC 15",
  "HRAC 22",
  "HRAC 27",
  "HRAC 15 + 5",
  "Nematicide N-UN",
  "n/a (adjuvant)",
  "Unknown"
];
